<template>
    <div class="scan-graphic d-flex flex-column justify-content-center align-items-center">
        <i class="fa-duotone fa-scanner fa-10x"></i>
        <div class="display-4 mt-4 text-muted">Scan Order to Begin Bulk Editing</div>
    </div>
</template>

<script>
    export default {
        name: 'inventory-scan',
        created() {
            this.$barcodeScanner.init(rawBarcode => {
                this.$barcodeScanner.parseBarcode(rawBarcode, (barcode, context) => {
                    document.activeElement.blur();
                    this.$bvToast.toast('Scanned barcode "' + barcode + '"', {
                        title: 'Barcode Scanner',
                        appendToast: true,
                        autoHideDelay: 3000,
                    });
                    this.$router.push({path: '/inventory/edit-safe/?scan=' + encodeURIComponent((context ? context : '') + barcode)});
                });
            });
        }
    };
</script>

<style scoped>
    i {
        font-size: 18rem;
        color: gray;
    }

    .scan-graphic {
        height: 75vh;
    }
</style>
